import { useMutation } from '@tanstack/react-query';
import { authApi } from '@/Api/auth-v2.api';

/**
 * Hook partage pour changer le mot de passe de l'utilisateur connecte.
 * Sans notifications — chaque consommateur gere les siennes.
 */
export const useChangePassword = () => {
  return useMutation({
    mutationFn: ({ oldPassword, newPassword }: { oldPassword: string; newPassword: string }) =>
      authApi.changePassword(oldPassword, newPassword),
  });
};
